var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        { on: { click: _vm.open } },
        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "font-weight": "normal" },
          attrs: {
            visible: _vm.isOpen,
            top: "50px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
            close: function ($event) {
              return _vm.cancel()
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("div", { staticClass: "el-dialog__title" }, [
              _vm._v("\n        Manage devices - Location "),
              _c("b", [_vm._v(_vm._s(_vm.locationName))]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-info-card" },
            [
              _c("h2", { staticClass: "section-title" }, [
                _vm._v("\n        Customer\n      "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "user-info" }, [
                _c(
                  "span",
                  { staticClass: "icon-row" },
                  [_c("font-awesome-icon", { attrs: { icon: "user" } })],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "user-detail" }, [
                  _vm._v(_vm._s(_vm.fullName)),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "user-info" }, [
                _c(
                  "span",
                  { staticClass: "icon-row" },
                  [_c("font-awesome-icon", { attrs: { icon: "envelope" } })],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "user-detail" }, [
                  _vm._v(_vm._s(_vm.currentUser.email)),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "user-info" }, [
                _c(
                  "span",
                  { staticClass: "icon-row" },
                  [_c("font-awesome-icon", { attrs: { icon: "phone" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "user-detail",
                    class: { disabled: !_vm.currentUser.phone_number },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.currentUser.phone_number || "no data available"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h2", { staticClass: "section-title" }, [
                _vm._v("\n        Devices\n      "),
              ]),
              _vm._v(" "),
              _vm._l(_vm.allDevices, function (device) {
                return _c(
                  "div",
                  { key: device.doorbot_id, staticClass: "device-rows" },
                  [_c("device-user-row", { attrs: { auth: device } })],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }